export default __webpack_public_path__ + "static/media/DIABETE_ICONA.bcc9dcb0.svg";